import * as React from 'react';
import { JSX, ReactNode, useContext, useState } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Layout } from '../../Layout';
import { AdminIndexing } from './AdminIndexing';
import { AdminJobWrapper } from './importManagement/AdminJobWrapper';
import { AuthContext } from 'Auth/components/AuthProvider';
import { MenuItem } from 'primereact/menuitem';
import { Menu } from 'primereact/menu';
import { Block } from 'pages/edit/components/layout/Block';
import { AdminAreaOrcid } from './adminAreaOrcid/AdminAreaOrcid';

interface Content {
  roles: string[],
  title: string,
  component: JSX.Element
}

export function AdminAreaSystem(): ReactNode {

  const intl: IntlShape = useIntl();

  const [pageIsLoading, setPageIsLoading] = useState<boolean>(false);
  const [selectedPage, setSelectedPage] = useState<string>('userMenu.orcidManagement');

  const {session} = useContext(AuthContext);

  const contents: Content[] = [
    {
      roles: ['ROLE_ADMIN'],
      title: 'userMenu.orcidManagement',
      component: <AdminAreaOrcid />
    },
    {
      roles: ['ROLE_ADMIN'],
      title: 'admin.indizes',
      component: <AdminIndexing />
    },
    {
      roles: ['ROLE_ADMIN', 'ROLE_EDITOR'],
      title: 'userMenu.importManagement',
      component: <AdminJobWrapper setPageIsLoading={setPageIsLoading} />
    },
  ];

  const visibleContents: Content[] = contents.filter(
    (content: Content): boolean =>
      content.roles.some(
        (role: string): boolean => session.roles.includes(role)
      )
  );

  const menu: MenuItem[] = visibleContents.map(
    (content: Content): MenuItem => {

      const classNames: string[] = [];

      if (selectedPage === content.title) {
        classNames.push('active bg-primary');
      }

      return {
        label: intl.formatMessage({id: content.title}),
        className: classNames.join(' '),
        disabled: pageIsLoading,
        command: (): void => setSelectedPage(content.title),
      };
    }
  );

  const selectedContent: Content | undefined =
    visibleContents.find(
      (content: Content): boolean => content.title === selectedPage
    );

  return (
    <Layout
      title={intl.formatMessage({id: 'userMenu.adminSystem'})}
      isAdminAreaSystem={true}
      sidebarBreakpoint='lg'
      sidebarWidth={19}
      sidebarContent={
        <Block>
          <div className={'col-12 p-fluid'}>
            <Menu model={menu} id={'system-area-menu'}  />
          </div>
        </Block>
      }
    >
      <div className='flex gap-4'>
        <div className='flex-1 min-w-0'>{selectedContent?.component}</div>
      </div>
    </Layout>
  );
}
export default AdminAreaSystem;
